import supabase from "../supabase";

export const CHEQUES_CASH_ID = 7;

export const getPendingChecksTotal = async () => {
  const { data, error } = await supabase
    .from("paymentDetails")
    .select("checkAmount")
    .eq("paymentMethod", 7)
    .eq("checkState", 0);

  if (error) {
    console.error("Error al obtener el total de cheques pendientes:", error);
    throw error;
  }

  return (data || []).reduce(
    (sum, row) => sum + (parseFloat(row.checkAmount) || 0),
    0
  );
};

export const applyPendingChequesBalance = (cashes, pendingTotal) => {
  if (pendingTotal == null || Number.isNaN(pendingTotal)) {
    return cashes;
  }

  return (cashes || []).map((cash) =>
    Number(cash.cashId) === CHEQUES_CASH_ID
      ? { ...cash, balance: pendingTotal }
      : cash
  );
};

export const syncChequesCashBalance = async () => {
  const pendingTotal = await getPendingChecksTotal();
  const { error } = await supabase
    .from("cash")
    .update({ balance: pendingTotal })
    .eq("cashId", CHEQUES_CASH_ID);

  if (error) {
    throw error;
  }

  return pendingTotal;
};
